import script from "./GreenScreenShortcutsTip.vue?vue&type=script&setup=true&lang=js"
export * from "./GreenScreenShortcutsTip.vue?vue&type=script&setup=true&lang=js"

import "./GreenScreenShortcutsTip.vue?vue&type=style&index=0&id=26dbe1b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26dbe1b8"]])

export default __exports__